import React, { useCallback, useEffect, useState, Component } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SlideLayout } from '../components/deck/SlideLayout';
import { SlideNavigation } from '../components/deck/SlideNavigation';
// Import all slides
import { TitleSlide } from '../components/slides/TitleSlide';
import { ResetSlide } from '../components/slides/ResetSlide';
import { ProblemSlide } from '../components/slides/ProblemSlide';
import { SolutionSlide } from '../components/slides/SolutionSlide';
import { ClosedLoopSlide } from '../components/slides/ClosedLoopSlide';
import { CustomerJourneySlide } from '../components/slides/CustomerJourneySlide';
import { PlatformSlide } from '../components/slides/PlatformSlide';
import { DifferentiationSlide } from '../components/slides/DifferentiationSlide';
import { TractionSlide } from '../components/slides/TractionSlide';
import { RocheBlueprintSlide } from '../components/slides/RocheBlueprintSlide';
import { BusinessModelSlide } from '../components/slides/BusinessModelSlide';
import { MoatSlide } from '../components/slides/MoatSlide';
import { MarketSlide } from '../components/slides/MarketSlide';
import { TeamSlide } from '../components/slides/TeamSlide';
import { RaiseSlide } from '../components/slides/RaiseSlide';
import { NumbersSlide } from '../components/slides/NumbersSlide';
import { WhyInvestSlide } from '../components/slides/WhyInvestSlide';
import { CortexSlide } from '../components/slides/CortexSlide';
const SLIDES = [{
  component: TitleSlide,
  title: '',
  subtitle: ''
}, {
  component: ResetSlide,
  title: 'The Reset',
  subtitle: 'SaaS Breaking, SaS Rising'
}, {
  component: ProblemSlide,
  title: 'The Problem',
  subtitle: 'HCP Science Delivery Failing'
}, {
  component: CortexSlide,
  title: 'Snakker Cortex',
  subtitle: 'The Autopilot for Pharma Content'
}, {
  component: SolutionSlide,
  title: 'Solution',
  subtitle: 'Snaks Runtime'
}, {
  component: CustomerJourneySlide,
  title: 'Client Examples',
  subtitle: 'Real Snaks. Real Impact.'
}, {
  component: PlatformSlide,
  title: 'Platform Architecture',
  subtitle: 'AI driven Closed-Loop-Marketing'
}, {
  component: DifferentiationSlide,
  title: 'Differentiation',
  subtitle: 'Vertical Leadership'
}, {
  component: TractionSlide,
  title: 'Traction',
  subtitle: 'Pipeline Momentum'
}, {
  component: RocheBlueprintSlide,
  title: 'Expansion Strategy',
  subtitle: 'From Pilots to Scale: The Roche Blueprint'
}, {
  component: BusinessModelSlide,
  title: 'Business Model',
  subtitle: 'Recurring Runtime Revenue'
}, {
  component: MoatSlide,
  title: 'The Moat',
  subtitle: 'Codified Expertise + Data Loop'
}, {
  component: MarketSlide,
  title: 'Market & Timing',
  subtitle: '$100B Blue Ocean'
}, {
  component: TeamSlide,
  title: 'Team',
  subtitle: 'Proven Exits & Domain Expertise'
}, {
  component: RaiseSlide,
  title: 'The Raise',
  subtitle: 'Raising €2M'
}, {
  component: NumbersSlide,
  title: 'Financial Projections',
  subtitle: 'Accelerating Growth'
}, {
  component: WhyInvestSlide,
  title: 'Why Invest?',
  subtitle: 'Asymmetric Opportunity'
}];
export function InvestorDeck() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(0);
  const handleNext = useCallback(() => {
    if (currentSlide < SLIDES.length - 1) {
      setDirection(1);
      setCurrentSlide(prev => prev + 1);
    }
  }, [currentSlide]);
  const handlePrev = useCallback(() => {
    if (currentSlide > 0) {
      setDirection(-1);
      setCurrentSlide(prev => prev - 1);
    }
  }, [currentSlide]);
  const handleGoTo = (index: number) => {
    setDirection(index > currentSlide ? 1 : -1);
    setCurrentSlide(index);
  };
  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space') {
        handleNext();
      } else if (e.key === 'ArrowLeft') {
        handlePrev();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleNext, handlePrev]);
  const CurrentSlideComponent = SLIDES[currentSlide].component;
  return <div className="relative w-full h-screen bg-black overflow-hidden" data-id="element-588">
      <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-589">
        <motion.div key={currentSlide} custom={direction} initial={{
        x: direction > 0 ? 1000 : -1000,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: direction > 0 ? -1000 : 1000,
        opacity: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} className="absolute inset-0 w-full h-full" data-id="element-590">
          <SlideLayout slideNumber={currentSlide + 1} totalSlides={SLIDES.length} title={SLIDES[currentSlide].title} subtitle={SLIDES[currentSlide].subtitle} data-id="element-591">
            <CurrentSlideComponent data-id="element-592" />
          </SlideLayout>
        </motion.div>
      </AnimatePresence>

      <SlideNavigation currentSlide={currentSlide} totalSlides={SLIDES.length} onNext={handleNext} onPrev={handlePrev} onGoTo={handleGoTo} data-id="element-593" />
    </div>;
}